import { methodSteps, principles } from "../../../mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function AboutMethod() {
  return (
    <section id="about" className="scroll-mt-16 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="追踪说明"
          title="一套榜单是怎么"
          highlight="做出来的"
          desc="9看料不是一台只会搬运的机器，而是一套“捕捉—分档—计算—跟进—核对—刷新”的完整工序。下面的每一步，决定了你看到的热度排行可信与否。"
        />

        {/* steps */}
        <div className="mt-12 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 lg:grid-cols-3">
          {methodSteps.map((s, i) => (
            <div key={s.step} className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6">
              <span className="pointer-events-none absolute -right-2 -top-6 font-display text-7xl text-background-100">
                {s.step}
              </span>
              <div className="relative flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className={`${s.icon} w-5 h-5 flex items-center justify-center`}></i>
                </span>
                <div>
                  <h3 className="font-serif text-base font-bold text-foreground-950 md:text-lg">
                    <span className="mr-2 font-display text-sm text-primary-600">{s.step}</span>
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                </div>
              </div>
              {i < methodSteps.length - 1 && (
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-primary-400 transition-all duration-300 group-hover:w-full"></span>
              )}
            </div>
          ))}
        </div>

        {/* principles */}
        <div className="mt-6 overflow-hidden rounded-3xl bg-foreground-950 px-6 py-8 md:px-10 md:py-10">
          <div className="flex flex-col gap-2">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-wide text-accent-400">
              <i className="ri-verified-badge-fill w-4 h-4 flex items-center justify-center"></i>
              编辑与内容原则
            </span>
            <h3 className="font-serif text-2xl font-bold text-background-50">让吃瓜多一点克制与清醒</h3>
          </div>
          <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((p) => (
              <div key={p.title} className="rounded-2xl border border-white/10 bg-white/5 p-5">
                <i className={`${p.icon} w-6 h-6 text-accent-400 flex items-center justify-center`}></i>
                <h4 className="mt-3 font-serif text-base font-bold text-background-50">{p.title}</h4>
                <p className="mt-2 text-sm leading-relaxed text-background-200/90">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}